/* BALÈZE — minimal interactivity */
(function () {
  'use strict';

  // ============================================================
  // Scroll-driven reveal animations (IntersectionObserver)
  // ============================================================
  function initReveal() {
    var els = document.querySelectorAll('.bz-reveal, .bz-reveal-stagger');
    if (!els.length || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { observer.observe(el); });
  }

  // Auto-add .bz-reveal to all sections that don't have it yet
  function autoReveal() {
    var sections = document.querySelectorAll(
      '.bz-section, .bzh, .bzm, .bzs, .bzp, .bzf, [class*="shopify-section"] > section'
    );
    sections.forEach(function (s) {
      if (!s.classList.contains('bz-reveal') && !s.classList.contains('bz-reveal-stagger')) {
        s.classList.add('bz-reveal');
      }
    });
  }

  // ============================================================
  // Lazy-load background videos (below-fold) — perf
  // Video sources are held in data-src (nothing downloads on load).
  // When the section approaches the viewport, inject src + play().
  // Video stays 100% intact: same CDN files, muted/loop/playsinline autoplay on scroll.
  // ============================================================
  function loadLazyVideo(video) {
    if (!video || video.getAttribute('data-bz-loaded') === '1') return;
    video.setAttribute('data-bz-loaded', '1');
    var sources = video.querySelectorAll('source[data-src]');
    for (var i = 0; i < sources.length; i++) {
      var s = sources[i];
      if (!s.getAttribute('src')) s.setAttribute('src', s.getAttribute('data-src'));
    }
    video.load();
    // muted autoplay is allowed on scroll; play() returns a promise that can reject — swallow it
    var p = video.play();
    if (p && typeof p.catch === 'function') { p.catch(function () {}); }
  }

  function initLazyVideo() {
    var vids = document.querySelectorAll('[data-bz-lazy-video]');
    if (!vids.length) return;
    if (!('IntersectionObserver' in window)) {
      // no IO support: load immediately (graceful degradation)
      vids.forEach(function (v) { loadLazyVideo(v); });
      return;
    }
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          loadLazyVideo(entry.target);
          observer.unobserve(entry.target);
        }
      });
    }, { rootMargin: '300px 0px', threshold: 0.01 });
    vids.forEach(function (v) { observer.observe(v); });
  }

  // ============================================================
  // Init on DOM ready
  // ============================================================
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      autoReveal();
      initReveal();
      initLazyVideo();
    });
  } else {
    autoReveal();
    initReveal();
    initLazyVideo();
  }
})();
